import React from "react";
import Tr from "./Tr";
import Th from "./Th";
import { StyleSheet, Text, View } from "@react-pdf/renderer";

/**
 * This component is used to render the table body.
 * @param {object} props - The props object.
 * @param {object[]} props.headerData - The header data of the table.
 * @param {object[]} props.contentData - The content data of the table.
 * @param {number} props.fontSize - The font size of the table.
 * @param {number[]} props.widthArray - The width array of the table.
 * @param {string[]} props.fontSizeArray - The font size array of the table.
 * @returns {JSX.Element} - The component JSX element.
 */
const Thead = ({
  headerData,
  headerStyle,
  fontSize,
  widthArray,
  fontSizeArray,
}) => {
  const trWidth = "99";
  const sum = Array.isArray(widthArray)
    ? widthArray.reduce((a, b) => a + b, 0)
    : 0;
  return (
    <View>
      <Tr>
        {Array.isArray(headerData) &&
          headerData.map((item, index) => {
            return (
              <Th
                key={index}
                isLeft={index === 0}
                style={headerStyle}
                text={item.columnName}
                fontSize={
                  Array.isArray(fontSizeArray) && fontSizeArray[index]
                    ? fontSizeArray[index]
                    : fontSize
                }
                trWidth={trWidth}
                withWeight={
                  Array.isArray(widthArray) && widthArray.length > 0
                    ? widthArray[index] / sum
                    : 0
                }
              />
            );
          })}
      </Tr>
    </View>
  );
};

export default Thead;
